import { Box } from 'braid-design-system';
import React from 'react';

import { LINE_STATE } from '../constants';

import * as styles from './index.css';

const getLineStyle = (state: string, style: any) => {
  switch (state) {
    case LINE_STATE.GRAY_DOTTED_LINE:
      return style.inactive;
    case LINE_STATE.BLUE_LINE:
      return style.active;
    case LINE_STATE.GRAY_LINE:
      return style.visited;
    default:
      throw new Error(`Line getLineStyle - invalid state: ${state}`);
  }
};

interface LineProps {
  state: string;
}

export const Line = ({ state }: LineProps) => {
  const lineStyle = getLineStyle(state, styles);

  return <Box className={[styles.root, lineStyle]} />;
};
